export default __webpack_public_path__ + "static/media/assicura.3aac922f.png";